import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getMigratedSubscribers = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/reports/users-migration${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getChannelsMigrationStatus = async (
  params = '',
  signal = null
) => {
  const options = prepareRequestOptions(
    `/admin/reports/channels-migration${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getActiveSubscribers = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/reports/active-subscribers${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getTrialSubscribers = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/reports/trial-subscribers${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getUsersCount = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/reports/users-count${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getDailyWatchedSecondsAllData = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/reports/daily-watched-seconds-all`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getDailyWatchedSecondsAggregateData = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/reports/daily-watched-seconds-aggregate-migrated-apps`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
